// @flow

import React from 'react';

export const HistoryContext = React.createContext(
  {}, // default value
);
